<template>
  <v-app id="vuetify-app">
    <v-card flat>
      <v-card-text>
        <v-form v-model="formValid" lazy-validation ref="registrationForm" v-if="registrationSuccessful === false">
          <v-text-field
              v-model="userData.email"
              type="email"
              required
              :rules="rules.email"
              :label="`app.email` | trans"
              :error-messages="emailErrors"
          ></v-text-field>
          <v-text-field
              v-model="userData.password"
              type="password"
              required
              :rules="rules.password"
              :label="`app.password` | trans"
          ></v-text-field>
          <v-text-field
              v-model="userData.password_confirmation"
              type="password"
              required
              :rules="rules.password_confirmation"
              :label="`app.password_confirmation` | trans"
          ></v-text-field>
          <v-checkbox
              v-model="userData.termsAndConditions"
              :color="`success`"
              :rules="rules.terms_and_conditions"
              required
          >
            <template v-slot:label>
              <span v-html="getTermsAndConditionsLabel()"></span>
            </template>
          </v-checkbox>
          <v-checkbox
              v-model="userData.acceptanceOfTheNewsletter"
              :color="`success`"
              required
              :label="trans('app.acceptance_of_the_newsletter')"
          >
          </v-checkbox>
          <v-layout justify-end>
            <recaptcha :recaptcha-site-key="recaptchaSiteKey" ref="recaptcha"/>
          </v-layout>
          <v-layout align-center justify-center class="pt-5">
            <v-btn :disabled="!formValid || loading" :loading="loading" color="primary"
                   @click="register">{{ `app.start_free_trial` | trans }}
            </v-btn>
          </v-layout>
        </v-form>
        <v-layout v-if="registrationSuccessful">
          <p>{{ `app.auth.registration.remote_registration_successful` | trans }}</p>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
import axios from "axios";
import RulesBuilder from "../../utils/rulesBuilder";
import {trans} from "../../app";
import VueRecaptcha from 'vue-recaptcha';

export default {
  props: {
    routes: Object,
    recaptchaSiteKey: String,
    iframeOrigin: String,
    honeypot: Object
  },
  components: {VueRecaptcha},
  data() {
    return {
      loading: false,
      formValid: false,
      userData: {
        email: "",
        password: "",
        password_confirmation: "",
        termsAndConditions: false,
        acceptanceOfTheNewsletter: false,
      },
      rulesBuilder: new RulesBuilder(),
      registrationSuccessful: false,
      emailErrors: []
    };
  },
  computed: {
    rules() {
      return {
        email: this.rulesBuilder.addRequiredRule(trans('app.email'))
            .addMaxLengthRule(trans('app.email'), 255)
            .getRules(),
        password: this.rulesBuilder.addRequiredRule(trans('app.password'))
            .addMinLengthRule(trans('app.password'), 8)
            .getRules(),
        password_confirmation: this.rulesBuilder.addRequiredRule(trans('app.password_confirmation'))
            .addMinLengthRule(trans('app.password'), 8)
            .addSameRule(trans('app.password'), trans('app.password_confirmation'), this.userData.password)
            .getRules(),
        terms_and_conditions: this.rulesBuilder.addRequiredRule('').getRules(),
      }
    }
  },
  methods: {
    getTermsAndConditionsLabel() {
      return trans('app.acceptance_of_the_regulations');
    },
    register() {
      this.emailErrors = [];
      this.loading = true;

      if (this.$refs.registrationForm.validate() === false) {
        this.loading = false;
        return;
      }

      if (this.$refs.recaptcha.verify() === false) {
        this.loading = false;
        return;
      }

      let data = {
        email: this.userData.email,
        password: this.userData.password,
        password_confirmation: this.userData.password_confirmation,
        terms_acceptance: this.userData.termsAndConditions,
        g_recaptcha_response: this.$refs.recaptcha.getResponse(),
        newsletter: this.userData.acceptanceOfTheNewsletter,
      }

      if (this.honeypot.enabled) {
        data[this.honeypot.name_field_name] = '';
        data[this.honeypot.valid_from_field_name] = this.honeypot.encrypted_valid_from;
      }

      axios.post(this.routes.register, data)
          .then(() => {
            this.loading = false;
            this.registrationSuccessful = true;
            window.parent.postMessage({success:true}, this.iframeOrigin);
          }).catch((error) => {
        if (error.response && error.response.status === 422) {
          if (error.response.data?.errors?.email) {
            this.emailErrors = error.response.data?.errors?.email
          } else {
            this.$toast.error(trans('app.auth.registration.registration_failed'));
          }
        } else {
          this.$toast.error(trans('app.auth.registration.registration_failed'));
        }
        this.loading = false;
      })
    }
  },
  watch: {
    'userData.email'() {
      this.emailErrors = [];
    }
  },
};
</script>
<style scoped>
</style>
